import ErrorCodeHelper from '@dealroadshow/error-codes';
import { RpcError } from '@dealroadshow/json-rpc-dispatcher';
import Container from '@framework/di/Container';
import isServer from '@framework/router/Next/isServer';
import ClientReqData from '@framework/router/Next/headers/ClientReqData';
import { X_PATH_WITH_QUERY } from '@framework/router/Next/headers/setPathWithQueryToRequestHeader';
import { dataroomUrl } from '@dataroom/url';
import DataroomErrorHandler from '@dataroom/error-handler';
import { getTwoFactorViolationDataroomName } from '@dataroom/error-handler/getTwoFactorViolationDataroomName';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import {
  DataroomTwoFactorAuthenticationContextSymbol,
  type IDataroomTwoFactorAuthenticationContext,
} from '@dataroom/authentication/types';
import type { TDataroomResponseInterceptor } from './types';

export const dataroomTwoFactorAuthentication = (
  container: Container,
  tenant: DataroomTenant,
): TDataroomResponseInterceptor => async (response) => {
  if (!(response instanceof RpcError)) {
    return response;
  }

  if (response.getCode() !== ErrorCodeHelper.getCodeByName('DATAROOM_TWO_FACTOR_VIOLATION')) {
    return response;
  }

  if (isServer()) {
    const { headers } = await container.getAsync<ClientReqData>(ClientReqData);
    const pathWithQuery = headers[X_PATH_WITH_QUERY];
    const returnUrl = pathWithQuery ? dataroomUrl(tenant).getUrl(pathWithQuery) : null;

    container.get<DataroomErrorHandler>(DataroomErrorHandler).handleError(response, null, tenant, returnUrl);
    return response;
  }

  const {
    setTwoFactorAccessError,
    setModalData,
  } = container.get<IDataroomTwoFactorAuthenticationContext>(DataroomTwoFactorAuthenticationContextSymbol);

  setTwoFactorAccessError(true);

  setModalData({
    entityName: getTwoFactorViolationDataroomName(response),
  });

  return response;
};
